import React, { useState, useCallback, Fragment } from 'react'
import PropTypes from 'prop-types'

import { useRemovePromoCode } from '../PromoCodeMutation'

import { toast } from 'react-toastify'

import { ToastNotification, toastEachWarning } from '../../Modifiers/ToastNotification/ToastNotification'
import Error from '../../Error/Error'
import Loading from '../../Loading/Loading'

import CloseButton from '../../CloseButton/CloseButton'

import './PromoCode.css'

export const PromoCode = ({ name, cartGuid }) => {
  const [removePromoCodeError, setRemovePromoCodeError] = useState(null)
  const [removePromoCode, { loading, error, retry }] = useRemovePromoCode({
    onComplete: () => {
      toast(<ToastNotification checkmark>Promo code has been removed!</ToastNotification>)
    },
    onError: (error) => {
      setRemovePromoCodeError(error)
    },
    onCartOutOfStock: (message) => {
      // in the rare case that an item in cart went out of stock while user is applying promo code,
      // show out of stock warning
      toastEachWarning({ warnings: [message] })
    }
  })

  const handleRemovePromoCode = useCallback(() => {
    removePromoCode({ variables: { input: {
      cartGuid: cartGuid,
      discountType: 'RESTAURANT'
    }}})
  }, [ removePromoCode, cartGuid ])

  /**
   * error occurs during a network timeout/failed connection/failed fetch/etc, while a
   * removePromoCodeError occurs when the API call to remove the promo code fails for some reason.
  */
  return (
    <Fragment>
      { Boolean(error) && <Error error={error} retry={retry} />}
      { Boolean(removePromoCodeError) && <Error error={removePromoCodeError} />}
      <div styleName='promoCode' data-testid='promo-code'>
        { loading ? (<Loading style='secondary' />) : (
          <Fragment>
            <div styleName='promoCodeName'>{name}</div>
            <CloseButton
              onClick={handleRemovePromoCode}
              data-testid='promo-code-close-button'
            />
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

PromoCode.propTypes = {
  name: PropTypes.string.isRequired,
  cartGuid: PropTypes.string.isRequired
}
